import { useState, useEffect } from 'react';
import './../main-image.scss';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MainImage = () => {

  //const [mainImageUrl, setMainImageUrl] = useState('https://eepassv2prodmediastorage.blob.core.windows.net/file-data-public-images/EE%20PASS%20Website%20Graphic_Option%201.png');
  const [mainImageUrl, setMainImageUrl] = useState('/downloads/EEPASS_CoachingWithoutLimits_2000.png'); // do not use blob storage - no caching advantage
  return (
    <div className="main-image-container">
      <div className="image-container">
          <div id="mainImage">
            <img src={mainImageUrl} alt="Main Hero - EEPASS - Coaching without limits. Receive high-quality support as an educator no matter your role, 24/7, with EE PASS." />
          </div>
          {/* <div className="overlay">
            <div className="overlay-info">
              <div className="video-title">10,000 Hours of Learning</div>
              <p>
                Evolve as an educator with real-time access to individualized training and the
                support to improve instruction and evaluation.
              </p>
              <button className="play-btn" onClick={handlePlay}>
                <FontAwesomeIcon className="play-icon" icon={faPlay} />
                Watch Sample
              </button>
            </div>
          </div> */}
      </div>
    </div>
  );
};

export default MainImage;